import React from "react";
import { TeaWordmark } from "../../components/TeaWordmark";

/** Shared metallic wordmark: all gold in headers (allGold), gold · glossy teal · gold elsewhere. */
export function MetalWordmark({ className = "", small = false, allGold = false, stackMobile = false, testId = "metal-wordmark" }) {
  return <TeaWordmark variant={allGold ? "gold" : "tri"} small={small} stackMobile={stackMobile} testid={testId} className={`uppercase ${className}`} />;
}
